import { render, staticRenderFns } from "./Contrats.vue?vue&type=template&id=35f2bbda&"
import script from "./Contrats.vue?vue&type=script&lang=ts&"
export * from "./Contrats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports